var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{attrs:{"title":_vm.$gettext('quality') + ' : ' + _vm.$gettext(_vm.quality, 'quality_types')}},[_c('icon-quality',{attrs:{"quality":_vm.quality}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }